import request from "@/util/http";

export function listPointMall(params) {
  return request({ url: '/marketing/member/point_mall/list', method: 'get', params })
}

export function getPointGoods(id) {
  return request({ url: '/marketing/member/point_mall/view', method: 'get', params: { id } })
}

export function getPointLottery() {
  return request({ url: '/marketing/member/point_lottery/current', method: 'get' })
}

export function doPointLottery(lotteryId) {
  return request({ url: '/marketing/member/point_lottery/draw', method: 'post', data: { lotteryId } })
}
